module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 24v-6c0-1.106-.894-2-2-2H18v-4h2c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2h-8c-1.106 0-2 .894-2 2v8c0 1.106.894 2 2 2h2v4H4c-1.106 0-2 .894-2 2v6c-1.106 0-2 .894-2 2v4c0 1.106.894 2 2 2h4c1.106 0 2-.894 2-2v-4c0-1.106-.894-2-2-2v-4h8v4c-1.106 0-2 .894-2 2v4c0 1.106.894 2 2 2h4c1.106 0 2-.894 2-2v-4c0-1.106-.894-2-2-2v-4h8v4c-1.106 0-2 .894-2 2v4c0 1.106.894 2 2 2h4c1.106 0 2-.894 2-2v-4c0-1.106-.894-2-2-2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/network-1.js
// module id = 1295
// module chunks = 14